import type { IntlShape } from 'react-intl';

import { formatContentReportEpochTime } from '@confluence/macro-utils/entry-points/getRelativeTime.ts';

import type { ContentReportTableItem, SearchNode } from '../contentReportTableTypes.ts';
import { normalizeContentUrl } from '../contentReportTableUrlUtils.ts';

import { normalizeCreatorDisplayName } from './../contentReportTableUtils.ts';

const formatLastModified = (lastModified: string | null | undefined, intl: IntlShape): string => {
	if (!lastModified) {
		return '';
	}

	const timestamp = new Date(lastModified).getTime();
	if (Number.isNaN(timestamp)) {
		return lastModified;
	}

	return formatContentReportEpochTime(timestamp, intl);
};

export function mapSearchNodeToItem(
	node: SearchNode,
	intl: IntlShape,
): ContentReportTableItem | null {
	const normalizedUrl = normalizeContentUrl(node.url);

	if (!node.content || !node.title || !normalizedUrl) {
		return null;
	}

	return {
		id: node.content.id,
		title: node.title,
		url: normalizedUrl,
		lastModified: formatLastModified(node.lastModified, intl),
		creatorAccountId: node.content.creatorId ?? null,
		creatorDisplayName: normalizeCreatorDisplayName(
			node.content.history?.createdBy?.displayName,
			intl,
		),
		commentCount: node.content.comments?.count ?? 0,
		likeCount: node.content.likes?.count ?? 0,
		spaceKey: node.content.space?.key ?? '',
	};
}
